export const environment = {
    production: true,
    iMapToken: 'pk.eyJ1IjoibG1pMDAxIiwiYSI6ImNsYTlvZ3FvcDAwam0zcnBkaHVlZWlqeHIifQ.yVU5oak_a23V5U3xeUbAaA',
    api: {
        root: 'https://ivalidationapi-prod-cqbedfcbcua2bnf7.francecentral-01.azurewebsites.net/api/v1'
    }
};